exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".OKpVkqyaflD-A_aBRjSiy{max-width:100%;height:500px;background:black}\n", ""]);
// Exports
exports.locals = {
	"customTag": "OKpVkqyaflD-A_aBRjSiy"
};